// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-prestige -> dietz-property-group-prestige -> hunters-oak-apartments
// Generated: 2026-09-23T21:42:56.396Z
// Counts: 1 design, 11 content, 2 slot group, 2 collection binding, 7 section, 1 style

export const designOverrides = {
  "design.block:multihub-lead-form.color.primary": {
    "cssVariable": "--vibe-color-primary",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_secondary_color"
  }
};

export const contentOverrides = {
  "header.interactive_map_show_if_exists": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "interactivemapsection.map_block": {
    "overrideType": "VALUE",
    "customValue": "engrain-sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "adtaxi-tracking.profile": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_adtaxi_domain"
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "right-middle",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore affordable two- and three-bedroom apartment floor plans at Hunters Oak in Greenville, OH. Our LIHTC affordable housing community offers project-based Section 8 apartment homes for qualifying households.</p><p>Depending on the apartment home, income limits range from 40% to 60% of the Area Median Income (AMI). Housing Choice Vouchers are accepted. Browse our available floor plans and contact the leasing team for current qualification requirements.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Affordable 2 &amp; 3 Bedroom Apartments in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Hunters Oak, where spacious two- and three-bedroom apartments meet affordable living in Greenville, OH. Enjoy thoughtfully designed floor plans and convenient community amenities in a pet-friendly setting.</p><p>Hunters Oak participates in the Low-Income Housing Tax Credit (LIHTC) program and offers project-based Section 8 apartment homes. Depending on the apartment home, income limits range from 40% to 60% of the Area Median Income (AMI). Housing Choice Vouchers are also accepted.</p><p>Explore our affordable apartments in Greenville, OH, and contact our leasing team to learn more about current availability and income qualifications.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "petscallout.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162273/019e85db-45c6-7570-8b98-f085354e1af6.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Woman holding a dog indoors."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "communityamenitieslist.items": {
    "limit": null,
    "hiddenIds": [
      "custom_33577ad1-ac52-4ccb-8dfc-81f57bd9a79d",
      "custom_28b3465c-ee31-4ba4-96e4-9df44f72a61f",
      "custom_eb8d9046-b4e0-4b72-8285-de9cabfdedac",
      "custom_bbc59ed8-6bd7-415c-831e-520f134ef139"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      6,
      10,
      11,
      9
    ],
    "ordering": null,
    "customItems": null
  },
  "interioramenitieslist.items": {
    "limit": null,
    "hiddenIds": [
      "custom_0fa4f56d-45a1-4f5b-bc28-28deaf098c77",
      "custom_e9f4b5e1-73ea-4b0a-97d9-9d7c55108390"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      2,
      3
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "adtaxi-tracking",
      "blockId": "adtaxi-tracking",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "realpage-calendar",
      "blockId": "realpage-calendar",
      "position": 0
    }
  ]
};

export const styleOverrides = {
  "_section.InstagramSection": {
    "properties": {
      "display": "none"
    }
  }
};
